const actionTypes = {
	ALL_CARS: 'ALL_CARS',
	SINGLE_CAR: 'SINGLE_CAR',
	SIGN_UP: 'SIGN_UP',
	USER_SIGNUP: 'USER_SIGNUP',
	USER_SIGNUP_SUCCESS: 'USER_SIGNUP_SUCCESS',
	USER_SIGNUP_FAIL: 'USER_SIGNUP_FAIL',
	AUTHENTICATE: 'AUTHENTICATE',
	USER_LOGIN: 'USER_LOGIN',
	USER_LOGIN_FAIL: 'USER_LOGIN_FAIL',
	MY_CARS: 'MY_CARS',
	NEW_CAR: 'NEW_CAR',
	NEW_CAR_FAIL: 'NEW_CAR_FAIL',
	DELETE_CAR: 'DELETE_CAR',
};

export default actionTypes;
